var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThingsTwinsBlue = function SvgThingsTwinsBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 64,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3AACC8",
    d: "M35.308 59.615 27.713 64l-7.594-4.385 2.663-4.614 4.93 2.847L32.645 55zM5.328 44.924l4.93 2.846-2.664 4.614L0 48v-8.77h5.328zM55.426 48l-7.594 4.384-2.664-4.614 4.93-2.846V39.23h5.328zM44.879 22.089V41.91l-17.166 9.911-17.166-9.91V22.088l17.166-9.911zm-29.004 3.076v13.669l11.838 6.835 11.838-6.835V25.165L27.713 18.33zm-5.617-8.935-4.93 2.846v5.693H0V16l7.594-4.385zM55.426 16v8.769h-5.328v-5.693l-4.93-2.846 2.664-4.615zM35.308 4.384l-2.664 4.614-4.931-2.846-4.93 2.846-2.664-4.614L27.713 0z"
  })));
};
export { SvgThingsTwinsBlue as ReactComponent };
export default __webpack_public_path__ + "fac9e356dcb350a11f89b61d5bde5ac0.svg";